(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-set-betslip-items-count.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-set-betslip-items-count.js'); "use strict";


const {
  betslip
} = svs.sportsbook.sbtech_api_impl;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_setBetSlipItemsCount = () => itemsCount => betslip.updateCount(itemsCount);
 })(window);